import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import { GhostButton, Tooltip } from "@bst/react-ui";
import { MODAL_CLOSE_BTN_ID } from '../utils/constants';

type Props = {
  onCloseHandler?: () => void;
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

export function HyperFocusCloseBtn({ onCloseHandler, ...rest }: Props) {
  const { t } = useTranslation();
  return (
    <Tooltip content={t("close")}>
      <div>
        <GhostButton
          onClick={onCloseHandler}
          aria-label="Close"
          data-testid="modal-close"
          icon="icon-close"
          id={MODAL_CLOSE_BTN_ID}
        />
      </div>
    </Tooltip>
  );
}